import "./index.css";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "core-js/stable";
import "regenerator-runtime/runtime";
import { store } from "./store";
import { createTheme, ThemeProvider } from "@mui/material";
import { Provider } from "react-redux";

const theme = createTheme({
  palette: {
    primary: {
      light: "rgba(0, 109, 166, 0.5) !important",
      main: "#00558B",
      dark: "#14385F",
      contrastText: "#fff",
    },
    grey: {
      200: "rgba(0, 109, 166, 0.11)",
      500: "#808080",
      700: "#6A6A6A",
    }
  },
  typography: {
    h1: "32px",
    h2: "28px",
    h3: "24px",
    h4: "22px",
    h5: "16px",
    h6: "15px",
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
          tooltip: {
            fontSize: '14px'
          }
      }
    }
  }
});
const renderApp = () => {
  ReactDOM.render(
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>,
    document.getElementById("root")
  );
};
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if (process?.env?.NODE_ENV !== "production" && module.hot) {
  module.hot.accept("./App", renderApp);
}
renderApp();
